module.exports = __webpack_public_path__ + "media/homepage/matching-algorithm-85e9f686.webp";